import { Box, Text } from 'grommet';
import React from 'react';
import { isPhone } from '../../../services/utils';

const LineBox = ({ leftText, rightChild, size }) => (
    isPhone(size) ?
        <Box width={'large'} direction={'column'} gap='small'>
            <Box>
                <Text>{leftText}</Text>
            </Box>
            {rightChild}
        </Box> :

        <Box width={'large'} direction={'row'} align='center' justify='center' gap='medium'>
            <Box>
                <Text>{leftText}</Text>
            </Box>
            {rightChild}
        </Box>
)

export default LineBox